import React from "react";
import Footer from "../components/Footer/Footer";
import Header from "../components/Header/Header";
import Sidebar from "../components/Sidebar/Sidebar";
import Video from "../components/Video/Video";
import { RootState } from "../store/store";
import { useSelector } from "react-redux";

const HomePage = () => {
  const playlist = useSelector((state: RootState) => state.audio.playlist);
  let currentIndexSong = useSelector(
    (state: RootState) => state.audio.currentIndexSong
  );
  const inforSongPlayer = useSelector(
    (state: RootState) => state.audio.inforSongPlayer
  );
  React.useEffect(() => {
    document.title =
      inforSongPlayer?.name && playlist?.playlistId === "spotify"
        ? inforSongPlayer?.name
        : "Lofi.co - Craft your focus environment";
  }, [
    currentIndexSong,
    inforSongPlayer?.name,
    playlist.songs,
    playlist?.playlistId,
  ]);
  return (
    <div className="home-page w-full overflow-hidden h-screen relative">
      <Header />
      <Video />
      <Sidebar />
      <Footer />
    </div>
  );
};

export default HomePage;
